<template>
  <div>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.xs"
      persistent
      v-model="dialog"
      width="60vw"
    >
      <v-card>
        <v-toolbar color="primary">
          <v-toolbar-title>Create Campaign Crypto</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              icon
              @click="
                resetForm();
                $emit('onClose');
              "
              :disabled="isCreating"
            >
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text v-show="!isCreating">
          <div class="body__form">
            <v-form ref="formCampaign" v-model="valid" lazy-validation>
              <v-radio-group
                row
                v-model="form.campaign_type"
                @change="
                  form.campaign_amount_point = 0;
                  form.campaign_amount_per_user = 0;
                  form.campaign_start_date = null;
                  form.campaign_end_date = null;
                  isLimitUser = false;
                "
              >
                <v-radio
                  color="primary"
                  label="Airdrop"
                  value="airdrop"
                ></v-radio>
                <v-radio
                  color="primary"
                  label="Redeem"
                  value="redeem"
                ></v-radio>
              </v-radio-group>
              <v-divider color="cornflowerblue"></v-divider>
              <v-layout row wrap class="mt-3">
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    :rules="[rules.required]"
                    label="Title TH"
                    v-model="form.campaign_title_th"
                  >
                  </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    label="Title EN"
                    v-model="form.campaign_title_en"
                    :rules="[rules.required]"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pr-2">
                  <v-textarea
                    :rules="[rules.required]"
                    label="Description TH"
                    v-model="form.campaign_description_th"
                  >
                  </v-textarea>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-textarea
                    label="Description EN"
                    v-model="form.campaign_description_en"
                    :rules="[rules.required]"
                  ></v-textarea>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex xs12 sm6 class="pr-2">
                  <v-select
                    label="Limit per user"
                    :items="[
                      { name: 'Yes', value: true },
                      { name: 'No', value: false },
                    ]"
                    item-text="name"
                    item-value="value"
                    v-if="form.campaign_type == 'redeem'"
                    row
                    v-model="isLimitUser"
                    @change="form.campaign_amount_per_user = 0"
                  >
                  </v-select>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-text-field
                    v-if="form.campaign_type == 'redeem' && isLimitUser == true"
                    :rules="[rules.required, rules.moreThan, rules.onlyNumber]"
                    v-model="form.campaign_amount_per_user"
                    label="Amount Per User"
                    type="number"
                  ></v-text-field>
                </v-flex>
              </v-layout>
              <v-layout row wrap>
                <v-flex
                  xs6
                  sm6
                  class="pr-2"
                  v-if="form.campaign_type == 'redeem'"
                >
                  <v-text-field
                    :rules="[rules.required, rules.point, rules.onlyNumber]"
                    v-model="form.campaign_amount_point"
                    label="Amount point"
                    type="number"
                  ></v-text-field>
                </v-flex>
                <v-flex xs6 sm6 class="pr-2">
                  <v-text-field
                    :rules="[rules.required, rules.moreThan]"
                    v-model="form.campaign_amount_token"
                    label="Amount token"
                    type="number"
                  ></v-text-field>
                </v-flex>
              </v-layout>

              <v-text-field
                v-if="form.campaign_type == 'redeem'"
                :rules="[rules.required, rules.moreThan, rules.onlyNumber]"
                v-model="form.campaign_amount_redeem"
                label="Total Amount"
                type="number"
              ></v-text-field>

              <v-layout row wrap v-if="form.campaign_type == 'redeem'">
                <v-flex xs12 sm6 class="pr-2">
                  <v-menu
                    ref="menuDateStart"
                    v-model="menuDateStart"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.campaign_start_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.campaign_start_date"
                        label="Start Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="[
                          rules.required,
                          moment(form.campaign_start_date) <
                            moment(form.campaign_end_date) ||
                            'invalid date start - end',
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      color="black"
                      v-model="form.campaign_start_date"
                      year-icon="mdi-calendar-blank"
                      prev-icon="mdi-skip-previous"
                      next-icon="mdi-skip-next"
                      @change="
                        $refs.menuDateStart.save(form.campaign_start_date)
                      "
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm6 class="pr-2">
                  <v-menu
                    ref="menuDateEnd"
                    v-model="menuDateEnd"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="form.campaign_end_date"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="form.campaign_end_date"
                        label="End Date"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                        :rules="[
                          rules.required,
                          moment(form.campaign_start_date) <
                            moment(form.campaign_end_date) ||
                            'invalid date start - end',
                        ]"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :min="moment().format('YYYY-MM-DD')"
                      color="black"
                      v-model="form.campaign_end_date"
                      year-icon="mdi-calendar-blank"
                      prev-icon="mdi-skip-previous"
                      next-icon="mdi-skip-next"
                      @change="$refs.menuDateEnd.save(form.campaign_end_date)"
                    ></v-date-picker>
                  </v-menu>
                </v-flex>
              </v-layout>
              <v-divider class="my-3" color="cornflowerblue"></v-divider>
              <div class="mt-3" v-if="form.campaign_type == 'airdrop'">
                <div>
                  <span style="font-size: 16px">Customer list:</span>
                  <v-btn
                    v-if="customerFileName == ''"
                    icon
                    color="info"
                    class="white--text"
                    @click="$refs.dataTableInput.click()"
                  >
                    <v-icon dark>cloud_upload</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    v-else
                    @click="customerListDialog = true"
                    color="black"
                  >
                    <v-icon style="font-size: 30px; color: white"
                      >search</v-icon
                    >
                  </v-btn>
                </div>
                <div>
                  <span>{{ customerFileName }}</span>
                  <v-btn
                    icon
                    @click="$refs.dataTableInput.click()"
                    v-if="customerFileName != ''"
                  >
                    <v-icon flat>edit</v-icon>
                  </v-btn>
                </div>
                <div style="color: red">* Only .xlsx file</div>
                <div style="color: red">
                  * Field sheet must be including customer_id,
                  customer_first_name, customer_last_name, wallet_address,
                  wallet_provider
                </div>
                <div style="color: red">
                  * Customer list Must be less than 5000 person
                </div>
                <input
                  style="display: none"
                  type="file"
                  @change="onDataTableInput"
                  ref="dataTableInput"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </div>
              <v-divider class="my-3" color="cornflowerblue"></v-divider>
              <v-layout row align-center class="mt-3">
                <span style="font-size: 16px">Upload image:</span>
                <v-btn
                  icon
                  color="info"
                  class="white--text"
                  @click="$refs.LogoInput.click()"
                >
                  <v-icon dark>cloud_upload</v-icon>
                </v-btn>
                <input
                  style="display: none"
                  type="file"
                  @change="onLogoSelected"
                  ref="LogoInput"
                  accept="image/*"
                />
              </v-layout>
              <v-img
                :src="imageSrc"
                v-if="imageSrc"
                width="100px"
                height="100px"
              />
              <v-divider class="my-3" color="cornflowerblue"></v-divider>
              <v-layout row align-center>
                <span style="font-size: 18px">Condition detail</span>
                <v-divider class="mx-2" inset vertical></v-divider>
                <v-btn
                  color="success"
                  icon
                  @click="
                    form.campaign_condition_detail.push({
                      th: '',
                      en: '',
                    })
                  "
                >
                  <v-icon>add</v-icon>
                </v-btn>
              </v-layout>
              <v-layout
                row
                v-for="(condition, key) in form.campaign_condition_detail"
                :key="key"
                class="pa-3 mt-3"
                style="
                  border: 1px solid black;
                  border-radius: 10px;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <v-flex xs10>
                  <v-layout row wrap>
                    <v-flex xs12 md6 class="pr-2">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Condition TH"
                        v-model="condition.th"
                      >
                      </v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 class="pr-2">
                      <v-text-field
                        :rules="[rules.required]"
                        label="Condition EN"
                        v-model="condition.en"
                      >
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                <v-flex xs1 style="display: flex; justify-content: center">
                  <v-btn
                    color="error"
                    icon
                    small
                    @click="removeConditionDetail(key)"
                    v-if="key > 0"
                  >
                    <v-icon small>close</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-form>
          </div>
        </v-card-text>
        <v-card-text v-show="isCreating" class="text-xs-center">
          <div class="body__form">
            <span>Creating campaign crpyto ...</span>
            <v-progress-linear
              :indeterminate="true"
              color="primary"
            ></v-progress-linear>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions
          v-show="!isCreating"
          style="display: flex; justify-content: flex-end; align-items: center"
        >
          <v-btn
            flat
            color="error"
            style="border: 1px solid red"
            @click="$emit('onClose')"
            >cancel</v-btn
          >
          <v-btn
            flat
            color="success"
            style="border: 1px solid green"
            @click="createCampaign()"
            >save</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="customerListDialog">
      <v-card>
        <v-card-title
          ><h2>Imported Customer List</h2>
          <v-spacer></v-spacer>
          <v-btn icon @click="customerListDialog = false"
            ><v-icon>close</v-icon></v-btn
          >
        </v-card-title>
        <v-card-text>
          <div
            style="border: 1px solid black; border-radius: 10px"
            class="pb-3 px-3"
          >
            <div class="pb-3">
              <v-text-field
                prepend-icon="search"
                label="Search first name, last name, wallet_address, wallet_provider"
                single-line
                hide-details
                v-model="searchCustomer"
              ></v-text-field>
            </div>
            <div style="max-height: 60vh; overflow: auto">
              <v-data-table
                :headers="customerTableHeaders"
                :items="filteredCustomerList"
                :rows-per-page-items="[25, 50, 100, 500, 1000, 2000]"
              >
                <template v-slot:items="props">
                  <tr>
                    <td>
                      {{ props.item.customer_id }}
                    </td>
                    <td>
                      {{ props.item.customer_first_name }}
                    </td>
                    <td>
                      {{ props.item.customer_last_name }}
                    </td>
                    <td>
                      {{ props.item.wallet_address }}
                    </td>
                    <td>
                      {{ props.item.wallet_provider }}
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="openSnackbar" color="black" :timeout="3000">
      <v-icon color="warning" class="pr-1">warning</v-icon>
      {{ snackbarMsg }}
      <v-btn icon @click="openSnackbar = false">
        <v-icon color="red">close</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import XLSX from "./../../../../node_modules/xlsx/dist/xlsx.full.min.js";
export default {
  props: ["dialog"],
  data() {
    return {
      snackbarMsg: "",
      openSnackbar: false,
      customerTableHeaders: [
        {
          text: "customer_id",
          align: "left",
          sortable: false,
        },
        {
          text: "customer_first_name",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "customer_last_name",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "wallet_address",
          align: "center",
          sortable: false,
          value: "",
        },
        {
          text: "wallet_provider",
          align: "center",
          sortable: false,
          value: "",
        },
      ],
      isLimitUser: false,
      searchCustomer: "",
      customerListDialog: false,
      customerList: [],
      customerFileName: "",
      valid: true,
      isCreating: false,
      menuDateStart: false,
      menuDateEnd: false,
      rules: {
        onlyNumber: (value) => /^[^\W_]+$/.test(value) || "invalid format",
        moreThan: (value) => value > "0" || "More than zero.",
        point: (value) => value >= "0" || "invalid amount point.",
        required: (value) => value == "0" || !!value || "Required.",
        maxCode: (v) => v.length <= 6 || "No more than 6 characters",
      },
      imageSrc: "",
      form: {
        campaign_type: "airdrop",
        campaign_amount_point: 0,
        campaign_amount_token: 6.0,
        campaign_start_date: null,
        campaign_end_date: null,
        campaign_image: "",
        campaign_title_th: "รับ wetoken 6 coin",
        campaign_title_en: "airdrop wetoken 6 coin",
        campaign_description_th:
          "ลูกค้าที่เชื่อมต่อกระเป๋าบิทคับเน็ตรับเลย wetoken",
        campaign_description_en: "connect wallet bitkubnext wetoken now",
        campaign_condition_detail: [
          {
            th:
              "ลูกค้าสามารถเข้าร่วม campaign โดยการเชื่อมต่อกระเป๋า bitkub next ผ่านหัวข้อเชื่อมต่อกระเป๋า",
            en:
              "Customers can join the campaign by connecting the bitkub next wallet via the link to the wallet.",
          },
          {
            th:
              "ลูกค้าสามารถเข้าร่วม campaign โดยการเชื่อมต่อกระเป๋า bitkub next ผ่านหัวข้อเชื่อมต่อกระเป๋า",
            en:
              "Customers can join the campaign by connecting the bitkub next wallet via the link to the wallet.",
          },
        ],
        data_transactions: [],
        campaign_amount_per_user: 0,
        campaign_amount_redeem: 100,
      },
    };
  },
  watch: {
    dialog() {
      if (this.dialog == true) {
        this.isCreating = false;
        this.customerFileName = "";
        this.customerList = [];
        this.imageSrc = "";
        this.isLimitUser = false;
      }
    },
  },
  computed: {
    filteredCustomerList() {
      return this.customerList.filter(
        (val) =>
          (val.customer_first_name + " " + val.customer_last_name)
            .toLowerCase()
            .includes(this.searchCustomer.toLowerCase()) ||
          val.wallet_address.includes(this.searchCustomer) ||
          val.wallet_provider
            .toLowerCase()
            .includes(this.searchCustomer.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions({
      createCampaignCrypto: "campaigns/createCampaignCrypto",
    }),
    resetForm() {
      this.form = {
        campaign_type: "airdrop",
        campaign_amount_point: 0,
        campaign_amount_token: 6.0,
        campaign_start_date: null,
        campaign_end_date: null,
        campaign_image: "",
        campaign_title_th: "รับ wetoken 6 coin",
        campaign_title_en: "airdrop wetoken 6 coin",
        campaign_description_th:
          "ลูกค้าที่เชื่อมต่อกระเป๋าบิทคับเน็ตรับเลย wetoken",
        campaign_description_en: "connect wallet bitkubnext wetoken now",
        campaign_condition_detail: [
          {
            th:
              "ลูกค้าสามารถเข้าร่วม campaign โดยการเชื่อมต่อกระเป๋า bitkub next ผ่านหัวข้อเชื่อมต่อกระเป๋า",
            en:
              "Customers can join the campaign by connecting the bitkub next wallet via the link to the wallet.",
          },
          {
            th:
              "ลูกค้าสามารถเข้าร่วม campaign โดยการเชื่อมต่อกระเป๋า bitkub next ผ่านหัวข้อเชื่อมต่อกระเป๋า",
            en:
              "Customers can join the campaign by connecting the bitkub next wallet via the link to the wallet.",
          },
        ],
        data_transactions: [],
        campaign_amount_per_user: 0,
        campaign_amount_redeem: 0,
      };
    },
    removeConditionDetail(key) {
      if (this.form.campaign_condition_detail.length > 1) {
        this.form.campaign_condition_detail.splice(key, 1);
      }
    },
    async createCampaign() {
      if (this.form.campaign_type == "airdrop" && this.customerFileName == "") {
        this.openSnackbar = true;
        this.snackbarMsg = "กรุณานำเข้ารายชื่อลูกค้า";
        return;
      }

      if (this.$refs.formCampaign.validate()) {
        let payload = JSON.parse(JSON.stringify(this.form));
        if (payload.campaign_type == "airdrop") {
          payload.data_transactions = this.customerList.map((val) => {
            return {
              wallet_address: val.wallet_address,
              user_id: val.customer_id,
            };
          });
        }
        if (this.imageSrc == "") {
          delete payload.campaign_image;
        } else {
          payload.campaign_image = this.imageSrc;
        }

        this.isCreating = true;
        let result = await this.createCampaignCrypto(payload);

        if (result == false) return (this.isCreating = false);
        this.resetForm();
        result["campaign_crypto_amount_used"] = 0;
        this.$emit("onCreated", result);
      }
    },
    onDataTableInput(event) {
      let file = event.target.files[0];
      var reader = new FileReader();
      let _this = this;
      reader.onload = function(e) {
        var data = e.target.result;
        var workbook = XLSX.read(data, { type: "binary" });
        let sheetName = workbook.SheetNames[0];
        let worksheet = workbook.Sheets[sheetName];
        let rowObject = XLSX.utils.sheet_to_json(worksheet, { raw: false });
        if (rowObject.length > 5000) {
          _this.openSnackbar = true;
          _this.snackbarMsg = "รายชื่อต้องน้อยกว่า 5000 คน";
          return;
        }
        _this.customerFileName = file.name;
        _this.customerList = rowObject;
        console.log(rowObject);
      };
      reader.readAsBinaryString(file);
      event.target.value = "";
    },
    onLogoSelected(event) {
      let file = event.target.files[0];
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imageSrc = reader.result;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
  },
};
</script>

<style scoped>
.body__form {
  max-height: 400px;
  overflow: auto;
}

.body__form::-webkit-scrollbar {
  display: none;
}
</style>
